import { Icon, IconButton } from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import * as S from "../style";
import type { ValueConfig_V } from "@smartsuite/automation-engine-api";
import { useTranslation } from "react-i18next";
import { TextColorNames } from "@smartsuite/types";

export const BooleanValue = observer<{
  label: string | number;
  value?: ValueConfig_V;
  onRemove?: (index: number) => void;
  onEdit?: (index: number) => void;
  onlyStructure?: boolean;
  index?: number;
  fromArray?: boolean;
}>(({ label, value, onlyStructure, onRemove, onEdit, index, fromArray }) => {
  const { t } = useTranslation();
  if (value?.value.oneofKind !== "bool") {
    return null;
  }
  let text = `${label}: ${value.value.bool.toString()}`;

  if (onlyStructure) {
    text = fromArray
      ? `${t("caption.List")}: ${t("caption.Boolean")}`
      : t("caption.Boolean");
    text = index !== undefined && !fromArray ? `${label}: ${text}` : text;
  }

  return (
    <S.Root>
      <span>
        <S.IconWrapper>
          <Icon name="yes-and-no" size="S" color={TextColorNames.tertiary} />
        </S.IconWrapper>
        <S.Text>{text}</S.Text>
      </span>
      <S.StyledRemoveButton>
        <IconButton
          name="edit-thin"
          size="S"
          ariaLabel="Edit Button"
          color="currentColor"
          hoverColor="currentColor"
          onClick={() => index !== undefined && onEdit && onEdit(index)}
        />
        <S.Space />
        <IconButton
          name="trash-thin"
          size="S"
          ariaLabel="Remove Button"
          color="currentColor"
          hoverColor="currentColor"
          onClick={() => index !== undefined && onRemove && onRemove(index)}
        />
      </S.StyledRemoveButton>
    </S.Root>
  );
});
